import { render, staticRenderFns } from "./QueryFrame.vue?vue&type=template&id=129b54ce&scoped=true&"
import script from "./QueryFrame.vue?vue&type=script&lang=js&"
export * from "./QueryFrame.vue?vue&type=script&lang=js&"
import style0 from "./QueryFrame.vue?vue&type=style&index=0&id=129b54ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129b54ce",
  null
  
)

export default component.exports